import { Capacitor, registerPlugin } from '@capacitor/core';

/** Snapshot of "today" pushed to the Android home-screen widget. */
export interface WidgetStatus {
  earned: number;
  max: number;
  /** Pending chores due today (excludes overdue). */
  todo: number;
  done: number;
  skipped: number;
  /** Pending chores past their due date — disjoint from `todo`. */
  overdue: number;
  streak: number;
}

interface ChortleWidgetPlugin {
  update(status: WidgetStatus): Promise<void>;
  clear(): Promise<void>;
}

const ChortleWidget = registerPlugin<ChortleWidgetPlugin>('ChortleWidget');

/**
 * Push today's status to the native Android widget. No-op on web/iOS (the plugin
 * only exists on Android), and failures are swallowed — the widget is a nice-to-have
 * mirror of the dashboard, never load-bearing.
 */
export async function updateWidget(status: WidgetStatus): Promise<void> {
  if (Capacitor.getPlatform() !== 'android') return;
  try {
    await ChortleWidget.update(status);
  } catch {
    // Plugin missing or update failed — ignore.
  }
}

/** Flip the widget to its signed-out prompt (no active session). */
export async function clearWidget(): Promise<void> {
  if (Capacitor.getPlatform() !== 'android') return;
  try {
    await ChortleWidget.clear();
  } catch {
    // Plugin missing or update failed — ignore.
  }
}
